import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map } from 'rxjs'

import { Injectable } from '@angular/core'
import { ChangeRequestActions } from '../actions/change-request.actions'
import { ChangeItemType, ChangeType } from '../../model'

@Injectable()
export class ChangeRequestFeeEffects {
  constructor(private actions$: Actions) {}

  addScopeFee$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ChangeRequestActions.addScopeFee),
      map(({ data }) =>
        ChangeRequestActions.applyChanges({
          payload: {
            changeType: ChangeType.ADDED,
            type: ChangeItemType.SCOPE_FEE_ITEM,
            identity: data.id,
            data: { data },
          },
        })
      )
    )
  )

  addDeliverableFee$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ChangeRequestActions.addDeliverableFee),
      map(({ identity, parentId, data }) =>
        ChangeRequestActions.applyChanges({
          payload: {
            changeType: ChangeType.ADDED,
            type: ChangeItemType.DELIVERABLE_FEE_ITEM,
            identity,
            parentId,
            data: { data },
          },
        })
      )
    )
  )
}
